import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import {List} from 'material-ui/List';
import swal from 'sweetalert';
import {notify} from 'react-notify-toast';
import moment from 'moment';
import ModalMultipleRecords from '../../offers/components/ModalMultipleRecords';
import GenerateRegister from '../../offers/components/GenerateRegisterSocial';
import RaisedButton from 'material-ui/RaisedButton';

var Config = require('../../../config');

class ModalSocial extends Component{
    constructor(props,context){
        super(props,context);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getQuestions =  this.getQuestions.bind(this);
        this.getAnswers = this.getAnswers.bind(this);
        this.savePre = this.savePre.bind(this);
        this.postObservaciones = this.postObservaciones.bind(this);
        this.onChangeAprobar= this.onChangeAprobar.bind(this);
        this.getRejection = this.getRejection.bind(this);
        this.newSingleRecord = this.newSingleRecord.bind(this);
        this.getUsrLLam = this.getUsrLLam.bind(this);
        this.reload = this.reload.bind(this);
        this.state={
            show: false,
            donor_name:"",
            donor_id:"",
            offer_number:"",
			      offer_date: "",
            biometrics:[],
            rejectionReasons: "",
            rejectionDays: "",
            rejectionId: "",
            rejection: [],
            preg: [],
            don_usr_llam:{},
            llam_priority:{},
            respuestas: [],
           aprobar: "",
           observaciones: "",
            item: {},
            caller_id:"",
        };
    }
    
    componentDidMount() {
        this.setState({donor_name: "response.sex" });
        this.props.onRef(this);
        this.getUsrLLam();
    }
   
    componentWillUnmount() {
     
		this.props.onRef(null)
	}
    handleClose() {
		this.setState({ show: false,item:{},photo:"",donor_name:"",offer_date:"" });
    //window.location.reload();
	}

    handleShow(id,donor, caller_id, name) {
        this.getQuestions();
        
		this.setState({ 
			show: true,
			offer_number:id,
      mostrarDiv: false,
			biometrics:[],
            item:{},
            donor_id:donor,
            donor_name: name,
			caller_id:caller_id
		});
        this.getAnswers(id);
        // console.log(this.state.respuestas);
	}
  getUsrLLam(){    
    fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_usr_llam',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
           'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
          don_usr_llam: response
        });
      // this.getItems();
    })
    fetch(Config.default.apiGateway.URL+'functional_criterion?code=LLAM_PRIORITY',{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
         'Content-Type': 'application/json',
      })
  })
  .then(response => response.json())
  .then(response => {
    this.setState({
        llam_priority: response
      });
    // this.getItems();
  })
    
  }    
  onChangeAprobar(event) {
    const value = event.target.value;
    this.setState({ aprobar: value });
    if (value === 'false') {
      this.setState({ mostrarDiv: true });
      this.getRejection();
      console.log(this.state.rejection);
    } else {
      this.setState({ mostrarDiv: false });
    }
  }

    getQuestions() {
        fetch(Config.default.apiGateway.URL+'/offers/Questions',{
          method: 'get',
          headers: new Headers({
            'Authorization': 'Bearer '+sessionStorage.getItem("token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).then(res => {
          if(res.ok){
            return res.json();
          } else {
            console.log(res.text())
          }
        }).then(data => {
          // Actualiza el estado con los datos obtenidos de la respuesta de la API
          this.setState({ preg: data })
          console.log("PREGUNTAS",this.state.preg);
        })
      }
      reload(){
        window.location.reload();
      }
      getAnswers(id) {
        fetch(Config.default.apiGateway.URL+'/offers/Answers?offer_id=' + id,{
          method: 'get',
          headers: new Headers({
            'Authorization': 'Bearer '+sessionStorage.getItem("token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).then(res => {
          if(res.ok){
            return res.json();
          } else {
            console.log(res.text())
          }
        }).then(data => {
          // Actualiza el estado con los datos obtenidos de la respuesta de la API
          this.setState({ respuestas: data })
          // console.log(this.state.respuestas);
        })
      }
      getRejection(){
        fetch(Config.default.apiGateway.URL+'/offers/RejectionSocial',{
          method: 'get',
          headers: new Headers({
            'Authorization': 'Bearer '+sessionStorage.getItem("token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).then(res => {
          if(res.ok){
            return res.json();
          } else {
            console.log(res.text())
          }
        }).then(data => {
          // Actualiza el estado con los datos obtenidos de la respuesta de la API
          this.setState({ rejection: data })
          
        })
      }
      renderOptions() {
        return this.state.rejection.map((name, index) => {
          return (
            <option key={index} value={name.id} data-rejection-days={name.rejection_days}>
              {name.name}
            </option>
          );
        });
      }
      postObservaciones(id, aprobar, observaciones, rejectionId, rejectionReasons, rejectionDays) {
        ;
        var obj = {
          id : id,
          observaciones: observaciones,
         aprobar : aprobar,
         rejectionId: rejectionId,
         rejectionReasons: rejectionReasons,
         rejectionDays: rejectionDays
        }
        
        fetch(Config.default.apiGateway.URL+'offers/Cuestionario',{ 
                        method: 'POST',
                        body:JSON.stringify(obj),
                      headers: new Headers({
                           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
                           'Accept': 'application/json',
                          'Content-Type': 'application/json',
                      })
                  }).then(response => {
                    //console.log("respuesta: ",response);
                       if(response !== undefined){
                         notify.show('Respuesta Guardada','success');
                         if (aprobar === "true"){
                         if( this.state.don_usr_llam.value != "NO_CALLER"){
                         this.newSingleRecord()
                         //this.reload();
                         }
                         else{
                          window.location.reload();
                         }
                        }else{
                          window.location.reload();
                        }
                         
                        //this.props.search();
                         
                           
                      //console.log(response);
                         //this.handleClose();
                      //console.log(this.handleClose());
                  }
               });
      }
      savePre(){
        
        this.state.aprobar= document.getElementById("aprobar").value;
        this.state.observaciones = document.getElementById("Observaciones").value;
         if (this.state.mostrarDiv == true){
          this.state.rejectionDays = document.getElementById("rejectionDays").value;
         }
        
       
          //Mensaje de verificación antes de realizar el guardado de la información
          swal({
              title: '¿Está seguro?',
              text: '¿Desea Guardar este registro?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: '¡Si, Guardar!',
              cancelButtonText: '¡No, Cancelar!',
              closeOnConfirm: true,
              closeOnCancel: true
          }, async (isConfirm)=> {
              if (isConfirm) {
            var res = await  this.postObservaciones(this.state.offer_number, this.state.aprobar, this.state.observaciones, this.state.rejectionId, this.state.rejectionReasons, this.state.rejectionDays );
    
            if(res !== undefined){
              swal('Buen Trabajo', 'Guardado','success');
             
            }
                  		
              }
          });
       
    
      } 
      newSingleRecord(){
        if(this.state.llam_priority.value === 'NO'){
          this.modal_multiple_records.handleShow();
        }else{
          this.generate_register.openModal();
        }
        // // this.waiting_modal.handleShow('Generando...');
        // var obj = {};
        // obj.num_records = 1;
        // obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
        
        //     fetch(Config.default.apiGateway.URL+'caller_actions_historySocial', {
        //   method: 'POST', // or 'PUT',
        //   body: JSON.stringify(obj), // data can be `string` or {object}!
        //   headers: new Headers({
        //     'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
        //     'Accept': 'application/json',
        //     'Content-Type': 'application/json;charset=UTF-8'
        //   })
        // }).then(res => {
        //   this.waiting_modal.handleClose();
        //   if(res.ok){
        //     return res.json();
        //   }else{
        //     res.text().then(function(result) {
        //       swal('¡Error!', result, 'error');
        //     });
        //   }})
        // .then(response => {
        //     if(response !== undefined){
        //       this.getItems();
        //       notify.show('Ficha generada','success');
        //     }
        // })
        // .catch(function(error) {
        //   console.log('There has been a problem with your fetch operation: ' + error.message);
        // });
      };
        handleSelectionChange(event) {
          const selectedOption = event.target.options[event.target.selectedIndex];
          const id = selectedOption.value;
          const name = selectedOption.text;
          const rejectionDays = selectedOption.dataset.rejectionDays;
          this.state.rejectionId = id;
          this.state.rejectionReasons = name;
          this.state.rejectionDays = rejectionDays;
          document.getElementById("rejectionDays").value = this.state.rejectionDays;
          
          
        }
        
     
    
    render(){
      const { mostrarDiv } = this.state;
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('Cuestionario')}</Modal.Title>
		        </Modal.Header>
                <Modal.Body style={{fontSize: "11px",}}>
                    <form>
                    <div className="row" >
                    
								
								<div className="col-xs-12">
									<label style={{marginRight:8}}>Donador:  </label>
									<span className="span-min">{this.state.donor_name} </span>
                                    <label style={{marginRight:8,marginTop:25}}>Ofrecimiento:</label>
								<span className="span-min">{this.state.offer_number} </span>
                                <label style={{marginRight:8,marginTop:25}}>Fecha: </label>
								<span className="span-min">{moment().format('DD/MM/YYYY')}</span>
								</div>
								
								
								
							
                    </div>
                    <div className="row" >
                    <div className="col-xs-12" style={{marginLeft:"10%", marginTop:"10"}}>
									<legend style={{marginRight:8}}>Cuestionario </legend>
									
								</div>

                    </div>
                    <div div className="row" >
                    <table   style={{border:"1px solid black"}}>
  <thead>
    <tr>
      <th>Pregunta</th>
      <th>Respuestas</th>
      <th style={{textAlign:"center"}}>Respuesta Adicional</th>
      <th>NOM-253-SSA1-2012</th>
      
    </tr>
  </thead>
  <tbody>
    {this.state.preg.map((pregunta) => {
      console.log("pregunta:", pregunta);
      const respuestas = this.state.respuestas.filter(
        (respuesta) => respuesta.pregunta_id === pregunta.id
      );
      // console.log("respuestas:", respuestas);
      return (
        <tr key={pregunta.id}>
          <td dangerouslySetInnerHTML={{ __html: pregunta.pregunta }}   style={{border:"1px solid black"}}></td>
          {respuestas.map((respuesta) => (
            <React.Fragment key={respuesta.id}>
              <td style={{
            border: "1px solid black",
            textAlign: "center",
            backgroundColor: respuesta.respuesta === pregunta.AlertaRespuesta  ? "rgb(235, 203, 200)" : "transparent",
              }}>{respuesta.respuesta}</td>
              <td
              style={{
                border: "1px solid black",
                textAlign: "center",
                backgroundColor: respuesta.respuesta === pregunta.AlertaRespuesta ? "rgb(235, 203, 200)" : "transparent",
                  }}
              >{respuesta.adicional}</td>
              <td
              dangerouslySetInnerHTML={respuesta.respuesta === pregunta.AlertaRespuesta ? { __html: pregunta.dis_nom } : null}
              style={{
                border: "1px solid black",
                textAlign: "center",
                backgroundColor: respuesta.respuesta === pregunta.AlertaRespuesta ? "rgb(235, 203, 200)" : "transparent",
                  }}
              ></td>
            </React.Fragment>
          ))}
        </tr>
      );
    })}
  </tbody>
</table>
    </div>
            
                    <div className="row" >
                    <div className="col-xs-12" style={{marginLeft:"10%"}}>
                      
									<label style={{marginRight:8}}> ¿PUEDE EL DONANTE CONTINUAR CON EL PROCESO DE DONACIÓN?: </label>
                  <select id="aprobar"  onChange={this.onChangeAprobar}>
          <option value="true">SI</option>
          <option value="false">NO</option>
        </select>

        {mostrarDiv && (
          <div name="rejections">
               <label style={{marginRight:8}}> CAUSA DE RECHAZO: </label>
             <select id="rejectReasons" style={{marginRight:8}} onChange={this.handleSelectionChange.bind(this)} required>
              <option value="" selected disabled> Seleccionar</option>
             {this.renderOptions()}
        </select>
        <label style={{marginRight:8}}> DIAS DE RECHAZO </label>
        <input type="number" id="rejectionDays" required/>
        <input type="hidden" id="rejectionId"   value={this.state.rejectionId}/>

          </div>
        )}
                                    
									
								</div>

                    </div>
                    <div className="row" >
                    <div className="col-xs-12" style={{marginLeft:"10%"}}>
									<label style={{marginRight:8}}> OBSERVACIONES </label>
                                                                    
									
								</div>

                    </div>
                    <div className="row" >
                    <div className="col-xs-12" style={{marginLeft:"10%"}}>
                    <textarea id="Observaciones" style={{ width: "325px", height: "89px", resize: "none" }}></textarea>
                    </div>

                    </div>
                    <div className="row" >
                    <div className="col-xs-12" style={{marginLeft:"10%"}}>
                    <RaisedButton className="action-btn" label={t('Guardar')} 
		        			onClick={this.savePre}
		        		/>
                                                                    
									
								</div>
                <ModalMultipleRecords 
          {...this.props} onRef={ref => (this.modal_multiple_records = ref)} 
          refresh={this.createdRecord}
        />
        <GenerateRegister {...this.props} refresh={this.createdRecord} onRef={ref => this.generate_register = ref} />
                    </div>
                    </form>
                </Modal.Body>
	      	</Modal>
		);
	}
}
export default translate('translations')(ModalSocial)